import React from 'react';

import { css } from '@emotion/react';
import { colors, gutterSizes, fontWeights } from '@gumtree/ui-library/src/base/theme';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';

export const StyledFilterBlock = ({ children, ...props }: React.PropsWithChildren) => {
    return (
        <div
            {...qaAttribute('filter-block-categories')}
            css={css`
                border-top: 1px solid ${colors.bark20};
                padding-top: ${gutterSizes.xlarge};
                margin-top: ${gutterSizes.large};

                .radio-switch + label {
                    font-weight: ${fontWeights.normal};
                }
            `}
            {...props}
        >
            {children}
        </div>
    );
};
